export const ADD_SUCCESS = 'Настройки добавлены';
export const ADD_ERROR = 'Не удалось добавить настройки';
